import LzMBase from '@lz-models/commons/Base';
import { LZ_DATE_FIELD_FORMAT, lzFGetFormattedDate } from '@lz-services/Moment';
import { getFormattedAmount } from 'services/Utils';
import PartyModel from 'modules/Params/Parties/party.model';
import SalesInvoiceDetailModel from './sales-invoice-detail.model';

export default class SalesInvoiceModel extends LzMBase {

    constructor(model) {
        super(model);

        this.invoice_no = model?.invoice_no || '';
        this.invoice_date = lzFGetFormattedDate(model?.invoice_date || '', LZ_DATE_FIELD_FORMAT, '');
        this.buyer_id = +(model?.buyer_id || 0);
        this.buyer_type = +(model?.buyer_type || 1);
        this.buyer_name = model?.buyer_name || '';
        this.buyer_code = model?.buyer_code || '0000';
        this.buyer_address = model?.buyer_address || '';
        this.buyer_province = model?.buyer_province || 'SINDH';
        this.buyer_strn = model?.buyer_strn || '';
        this.buyer_ntn = model?.buyer_ntn || '';
        this.buyer_cnic = model?.buyer_cnic || '';
        this.consignee_code = model?.consignee_code || '0000';
        this.consignee_name = model?.consignee_name || '-';
        this.transporter_code = model?.transporter_code || '0000';
        this.transporter_name = model?.transporter_name || '-';
        this.confirmation_order_no = model?.confirmation_order_no || '0000';
        this.reference_no = model?.reference_no || '0000';
        this.reference_date = lzFGetFormattedDate(model?.reference_date || '2025-07-01', LZ_DATE_FIELD_FORMAT, '');
        this.terms_of_payment = model?.terms_of_payment || '-';
        this.discount_rate = +(model?.discount_rate || 0);
        this.sales_tax_rate = +(model?.sales_tax_rate || 0);
        this.further_tax_rate = +(model?.further_tax_rate || 0);
        this.sales_invoice_details = SalesInvoiceDetailModel.parseArray(model?.sales_invoice_details, this.discount_rate, this.sales_tax_rate, this.further_tax_rate, this.is_buyer_registered);
        this.wht_rate = +(model?.wht_rate || 0);
        this.advance_value = +(model?.advance_value || 0);
        this.note = model?.note || '';
        this.despatch_date = lzFGetFormattedDate(model?.despatch_date || '2025-07-01', LZ_DATE_FIELD_FORMAT, '');
        this.sales_tax_invoice_no = model?.sales_tax_invoice_no || '';
        this.fbr_invoice_no = model?.fbr_invoice_no || '';
    }

    get is_buyer_registered() {
        return this.buyer_type === PartyModel.TYPE_REGISTERED;
    }

    get is_fbr_registered() {
        return this.fbr_invoice_no !== '';
    }

    get total_weight() {
        return this.sales_invoice_details.reduce((sum, { weight }) => sum + +weight, 0);
    }
    get total_quantity() {
        return this.sales_invoice_details.reduce((sum, { quantity }) => sum + +quantity, 0);
    }
    get total_amount() {
        return this.sales_invoice_details.reduce((sum, { amount }) => sum + +amount, 0);
    }
    get total_discount() {
        return this.sales_invoice_details.reduce((sum, { discount }) => sum + +discount, 0);
    }
    get total_discount_fmt() {
        return getFormattedAmount(this.total_discount, true, true);
    }

    get total_gross() {
        return this.sales_invoice_details.reduce((sum, { gross }) => sum + +gross, 0);
    }
    get total_gross_fmt() {
        return getFormattedAmount(this.total_gross, true, true);
    }

    get total_sales_tax() {
        return this.sales_invoice_details.reduce((sum, { sales_tax }) => sum + +sales_tax, 0);
    }
    get total_sales_tax_fmt() {
        return getFormattedAmount(this.total_sales_tax, true, true);
    }

    get total_further_tax() {
        return this.is_buyer_registered ? 0 : this.sales_invoice_details.reduce((sum, { further_tax }) => sum + +further_tax, 0);
    }
    get total_further_tax_fmt() {
        return getFormattedAmount(this.total_further_tax, true, true);
    }

    get total_tax() {
        return this.sales_invoice_details.reduce((sum, { total_tax }) => sum + +total_tax, 0);
    }
    get total_tax_fmt() {
        return getFormattedAmount(this.total_tax, true, true);
    }

    set gross_sales_value(_) { }
    get gross_sales_value() {
        /*
        if (!lzFIsArray(this.sales_invoice_details)) {
            return 0;
        }
        let sum = 0;
        for (const detail of this.sales_invoice_details) {
            sum += detail.amount;
        }
        return sum;
        */

        // return this.sales_invoice_details.reduce((sum, { amount }) => sum + +amount, 0);
        return this.total_amount;
    }

    set discount_value(_) { }
    get discount_value() {
        // return this.gross_sales_value * this.discount_rate / 100;
        return +this.total_discount;
    }

    set excl_st_wht_value(_) { }
    get excl_st_wht_value() {
        // return this.gross_sales_value - this.discount_value;
        return +this.total_gross;
    }

    set sales_tax_value(_) { }
    get sales_tax_value() {
        // return this.excl_st_wht_value * this.sales_tax_rate / 100;
        return +this.total_sales_tax;
    }

    set further_tax_value(_) { }
    get further_tax_value() {
        return +this.total_further_tax;
    }

    set wht_value(_) { }
    get wht_value() {
        return (this.excl_st_wht_value + this.sales_tax_value + (this.is_buyer_registered ? 0 : this.further_tax_value)) * this.wht_rate / 100;
    }

    set incl_st_wht_value(_) { }
    get incl_st_wht_value() {
        return this.excl_st_wht_value + this.sales_tax_value + (this.is_buyer_registered ? 0 : this.further_tax_value) + this.wht_value;
    }

    set invoice_value(_) { }
    get invoice_value() {
        return this.incl_st_wht_value - this.advance_value;
    }

    getObject() {
        return Object.assign({}, this, {
            gross_sales_value: this.gross_sales_value,
            discount_value: this.discount_value,
            sales_tax_value: this.sales_tax_value,
            further_tax_value: this.further_tax_value,
            wht_value: this.wht_value,
            invoice_value: this.invoice_value
        });
    }

    getJson() {
        /* This code below makes weired effect on the model in memory
        const data = Object.assign({}, this);
        delete data.id;
        delete data.name;
        delete data.buyer_id;
        delete data.is_active;
        delete data.created_at;
        delete data.created_by_id;
        delete data.updated_at;
        delete data.updated_by_id;
        delete data.deleted_at;
        delete data.deleted_by_id;
        for (const dex in data.sales_invoice_details) {
            delete data.sales_invoice_details[dex].id;
            delete data.sales_invoice_details[dex].name;
            delete data.sales_invoice_details[dex].item_id;
            delete data.sales_invoice_details[dex].created_at;
            delete data.sales_invoice_details[dex].created_by_id;
            delete data.sales_invoice_details[dex].updated_at;
            delete data.sales_invoice_details[dex].updated_by_id;
            delete data.sales_invoice_details[dex].deleted_at;
            delete data.sales_invoice_details[dex].deleted_by_id;
        }
            */

        return JSON.stringify({
            invoice_no: this.invoice_no,
            invoice_date: this.invoice_date,
            buyer_id: this.buyer_id,
            buyer_type: this.buyer_type,
            buyer_name: this.buyer_name,
            buyer_code: this.buyer_code,
            buyer_address: this.buyer_address,
            buyer_province: this.buyer_province,
            buyer_strn: this.buyer_strn,
            buyer_ntn: this.buyer_ntn,
            buyer_cnic: this.buyer_cnic,
            consignee_code: this.consignee_code,
            consignee_name: this.consignee_name,
            transporter_code: this.transporter_code,
            transporter_name: this.transporter_name,
            confirmation_order_no: this.confirmation_order_no,
            reference_no: this.reference_no,
            reference_date: this.reference_date,
            terms_of_payment: this.terms_of_payment,
            sales_invoice_details: this.sales_invoice_details.map((sid) => {
                return {
                    sno: sid.sno,
                    item_id: sid.item_id,
                    item_hs_code: sid.item_hs_code,
                    item_code: sid.item_code,
                    item_type_name: sid.item_type_name,
                    item_size_name: sid.item_size_name,
                    item_quality_name: sid.item_quality_name,
                    quantity: sid.quantity,
                    weight: sid.weight,
                    fbr_uom: sid.fbr_uom,
                    price: sid.price,
                    fbr_invoice_no: sid.fbr_invoice_no,
                };
            }),
            discount_rate: this.discount_rate,
            sales_tax_rate: this.sales_tax_rate,
            further_tax_rate: this.further_tax_rate,
            wht_rate: this.wht_rate,
            advance_value: this.advance_value,
            note: this.note,
            despatch_date: this.despatch_date,
            sales_tax_invoice_no: this.sales_tax_invoice_no,
            fbr_invoice_no: this.fbr_invoice_no,
        });
    }

    static parseArray(data) {
        return LzMBase.parseArray(data, SalesInvoiceModel);
    }

}
